import styled from "styled-components";

export const VideoPopupBox = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
  aspect-ratio: 320 / 497;
`;

export const VideoPopupImgBox = styled.div`
  width: 100%;
  position: relative;
`;

export const VideoPopupImg = styled.div`
  width: 100%;

  > img {
    width: 100%;
    aspect-ratio: 320 / 470;
    border-radius: 12px 12px 0 0;
  }
`;

export const ProgressDots = styled.div`
  position: absolute;
  display: flex;
  gap: 9px;
  align-items: center;
  justify-content: center;
  width: 100%;
  bottom: 30px;
  z-index: 1;

  > .dot {
    width: 10px;
    height: 10px;
    background: #808080;
    border-radius: 10.5px;
    transition: all 0.4s ease;
    border: 1px solid #6436e7;
  }

  > .dot.active {
    border-radius: 10.5px;
    width: 31px;
    background: var(--Purple-300, #6436e7);
    transition: all 0.4s ease;
  }
`;

export const VideoPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  z-index: 99999;
  overflow: hidden;
  touch-action: none;
  overscroll-behavior: contain;
`;

export const VideoPopupButtonWrapper = styled.div`
  position: absolute;
  bottom: -10px;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 48px;
  border-radius: 0 0 12px 12px;
  z-index: 10;
`;

export const VideoPopupButton = styled.div<{
  backgroundColor: string;
  color: string;
  borderRadius: string;
}>`
  flex: 1;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ color }) => color};
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
  border-radius: ${({ borderRadius }) => borderRadius};
`;

export const todayNotShowButton = styled.div`
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
`;
